import { useSnackbar } from 'notistack'

import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import CopyIcon from '@mui/icons-material/ContentCopy'
import { IconButton, Stack } from '@mui/material'

type Props = {
  copyText?: string
  status?: boolean
  allowCopy?: boolean
}

export const WebsocketCopyCell = ({ copyText, status, allowCopy = true }: Props) => {
  const { enqueueSnackbar } = useSnackbar()

  const handleCopy = () => {
    if (!copyText || !allowCopy) return
    navigator.clipboard.writeText(copyText)
    enqueueSnackbar('Websocket URL copied to clipboard!', { variant: 'success' })
  }

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      {status ? <CheckIcon fontSize="small" /> : <CloseIcon fontSize="small" />}
      {status}
      {allowCopy && (
        <IconButton onClick={handleCopy}>
          <CopyIcon />
        </IconButton>
      )}
    </Stack>
  )
}
